module.exports = __webpack_public_path__ + "media/images/how_it_works/jobs-8c6dcff1faa23d5956dc3cdf88fd69b9.svg";